import { useEffect, useMemo, useState } from "react";
import "@/App.css";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LangContext } from "@/lib/i18n";
import { scroller } from "@/lib/scroll";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { About } from "@/components/site/About";
import { Services } from "@/components/site/Services";
import { Bento } from "@/components/site/Bento";
import { Works } from "@/components/site/Works";
import { LeadMagnet } from "@/components/site/LeadMagnet";
import { Process } from "@/components/site/Process";
import { Pricing } from "@/components/site/Pricing";
import { Faq } from "@/components/site/Faq";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { ShareButton } from "@/components/site/ShareButton";
import { CookieBanner } from "@/components/site/CookieBanner";
import AdminPage from "@/pages/AdminPage";
import BlogPage from "@/pages/BlogPage";
import PostPage from "@/pages/PostPage";
import PrivacyPage from "@/pages/PrivacyPage";
import { BlogTeaser } from "@/components/site/BlogTeaser";
import { useLocation } from "react-router-dom";
import { scrollToId } from "@/lib/scroll";
import ThankYouPage from "@/pages/ThankYouPage";

const Home = () => {
  const [service, setService] = useState("social");
  const location = useLocation();

  useEffect(() => {
    const id = location.state?.scrollTo;
    if (!id) { window.scrollTo(0, 0); return undefined; }
    const t = setTimeout(() => scrollToId(id), 500);
    return () => clearTimeout(t);
  }, [location]);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.25, smoothWheel: true });
    scroller.lenis = lenis;
    let id;
    const raf = (time) => { lenis.raf(time); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); scroller.lenis = null; };
  }, []);

  return (
    <div className="site">
      <div className="grain" aria-hidden="true" />
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Services />
        <Works />
        <LeadMagnet />
        <Bento />
        <Process />
        <Pricing onPick={setService} />
        <BlogTeaser />
        <Faq />
        <Contact service={service} setService={setService} />
      </main>
      <Footer />
      <ShareButton />
    </div>
  );
};

function App() {
  const [lang, setLang] = useState("it");
  const ctx = useMemo(() => ({ lang, setLang }), [lang]);

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  return (
    <LangContext.Provider value={ctx}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<PostPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/grazie" element={<ThankYouPage />} />
        </Routes>
      </BrowserRouter>
      <CookieBanner />
      <Toaster theme="dark" position="bottom-center" />
    </LangContext.Provider>
  );
}

export default App;
